<template>
    <div class="p-2">

        <!-- Spedizioni non trasmesse (30/09/2026): i clienti non capivano che una bozza
             salvata non parte finche' non la trasmettono. Il numero e' su TUTTE le
             pagine dell'elenco, non solo su quella in vista. -->
        <div v-if="daTrasmettere > 0"
            class="mx-3 mt-3 p-3 rounded border-l-4 border-yellow-400 bg-yellow-50 text-sm text-gray-800">
            <b>{{ daTrasmettere }}</b>
            {{ daTrasmettere === 1 ? __('spedizione NON ancora trasmessa a Tardini: finché non la trasmetti non parte.')
                                   : __('spedizioni NON ancora trasmesse a Tardini: finché non le trasmetti non partono.') }}
            {{ __('Selezionale e premi') }} <b>{{ __('trasmetti selezionate') }}</b>.
        </div>

        <div class="flex flex-wrap items-center justify-between px-3 my-3">
            <div class="text-xs text-gray-600">
                <span v-if="selezionate.length > 0">
                    {{ selezionate.length }} {{ __('spedizioni selezionate') }}
                </span>
                <span v-else>
                    {{ __('Seleziona le spedizioni da trasmettere. Dopo la trasmissione non si modificano più.') }}
                </span>
            </div>
            <div class="flex flex-wrap items-center">
                <!-- 05/10/2026: di norma solo bozze, allarmi e spedizioni trasmesse oggi (08/10: era da ieri).
                     Lo storico completo si chiede qui. -->
                <label class="text-xs text-gray-700 mr-4 cursor-pointer"
                    :title="__('di norma si vedono le spedizioni da trasmettere e quelle trasmesse oggi')">
                    <input type="checkbox" v-model="mostraTutte" class="mr-1 align-middle">{{ __('mostra anche le più vecchie') }}
                </label>
                <button type="button" @click="carica(paginaCorrente)"
                    class="bg-gray-300 hover:bg-gray-400 text-gray-800 text-xs font-bold py-2 px-4 rounded mr-2">
                    {{ __('aggiorna') }}
                </button>
                <button type="button" @click="apriSceltaA4" :disabled="selEtichette.length === 0"
                    class="text-xs font-bold py-2 px-4 rounded mr-2 border"
                    :class="selEtichette.length === 0
                        ? 'bg-gray-400 border-gray-400 text-white cursor-not-allowed'
                        : 'bg-white border-red-600 text-red-600 hover:bg-red-50'"
                    :title="__('un foglio A4 con quattro etichette per pagina, in scala 1:1')">
                    {{ __('etichette A4') }}<span v-if="selEtichette.length > 0"> ({{ selEtichette.length }})</span>
                </button>
                <!-- 13/10/2026: le stesse etichette spuntate in un PDF solo, una per pagina grande
                     quanto l'etichetta (circa 10x10 cm). "termiche" e non "10x10": il cliente puo'
                     stampare anche su rotoli 10x15 (Michele). -->
                <button type="button" @click="stampaEtichette10x10" :disabled="selEtichette.length === 0"
                    class="text-xs font-bold py-2 px-4 rounded mr-2 border"
                    :class="selEtichette.length === 0
                        ? 'bg-gray-400 border-gray-400 text-white cursor-not-allowed'
                        : 'bg-white border-red-600 text-red-600 hover:bg-red-50'"
                    :title="__('tutte le etichette spuntate in un PDF solo, una per pagina, per la stampante di etichette (circa 10x10 cm): stampare a dimensioni effettive')">
                    {{ __('etichette termiche') }}<span v-if="selEtichette.length > 0"> ({{ selEtichette.length }})</span>
                </button>
                <button type="button" @click="conferma" :disabled="selezionate.length === 0"
                    class="text-white text-xs font-bold py-2 px-4 rounded"
                    :class="selezionate.length === 0
                        ? 'bg-gray-400 cursor-not-allowed'
                        : 'bg-red-600 hover:bg-red-800'">
                    {{ __('trasmetti selezionate') }}
                </button>
            </div>
        </div>

        <!-- Distinta di ritiro (08/10/2026): tutte le spedizioni trasmesse nel giorno
             scelto e non ancora in una distinta. Una spedizione sta in una distinta sola. -->
        <div class="flex flex-wrap items-center px-3 mb-3 text-xs text-gray-700">
            <span class="font-bold mr-2">{{ __('Distinta di ritiro') }}:</span>
            <input type="date" v-model="giornoDistinta" :max="oggi"
                class="text-xs bg-gray-200 border border-gray-200 rounded px-2 py-1 mr-2">
            <button type="button" @click="creaDistinta" :disabled="!giornoDistinta"
                class="text-xs font-bold py-2 px-4 rounded mr-6 border bg-white border-red-600 text-red-600 hover:bg-red-50"
                :title="__('mette in distinta le spedizioni trasmesse quel giorno che non sono ancora in una distinta')">
                {{ __('crea distinta') }}
            </button>
            <template v-if="distinte.length > 0">
                <span class="mr-2">{{ __('ristampa') }}:</span>
                <select v-model="distintaScelta"
                    class="text-xs bg-gray-200 border border-gray-200 rounded px-2 py-1 mr-2">
                    <option v-for="d in distinte" :key="d.id" :value="d.id">
                        {{ d.anno }}/{{ d.numero }} — {{ giornoIt(d.giorno) }} ({{ d.spedizioni }})
                    </option>
                </select>
                <button type="button" @click="stampaDistinta(distintaScelta)" :disabled="!distintaScelta"
                    class="bg-gray-300 hover:bg-gray-400 text-gray-800 text-xs font-bold py-2 px-4 rounded">
                    {{ __('stampa') }}
                </button>
            </template>
        </div>

        <div class="w-full overflow-x-auto px-3">
            <table class="min-w-full text-xs">
                <thead>
                    <tr class="text-left text-gray-700 uppercase font-bold border-b border-gray-300">
                        <th class="px-2 py-2">
                            <!-- Seleziona/deseleziona tutte le BOZZE DI QUESTA PAGINA: le righe
                                 gia' confermate non hanno la casella e non si toccano. -->
                            <input type="checkbox"
                                :disabled="bozzeInPagina.length === 0"
                                :indeterminate.prop="selezioneParziale"
                                v-model="tutteSelezionate"
                                :title="__('seleziona tutte le spedizioni da trasmettere di questa pagina')">
                        </th>
                        <th class="px-2 py-2">{{ __('Numero') }}</th>
                        <th class="px-2 py-2" :title="__('data di trasmissione; per le bozze, data di creazione')">{{ __('Data') }}</th>
                        <!-- 22/10/2026: data della LDV scelta nel modulo -->
                        <th class="px-2 py-2 whitespace-nowrap" :title="__('data della lettera di vettura')">{{ __('Data LDV') }}</th>
                        <th class="px-2 py-2">{{ __('Stato') }}</th>
                        <th class="px-2 py-2">{{ __('Rif. DDT') }}</th>
                        <th class="px-2 py-2">{{ __('Destinatario') }}</th>
                        <th class="px-2 py-2">{{ __('Località') }}</th>
                        <th class="px-2 py-2">{{ __('Colli') }}</th>
                        <th class="px-2 py-2">{{ __('Peso') }}</th>
                        <th class="px-2 py-2">{{ __('Volume') }}</th>
                        <th class="px-2 py-2 whitespace-nowrap">
                            <!-- 05/10/2026: seleziona/deseleziona per il foglio A4 tutte le
                                 etichette arrivate in QUESTA PAGINA (come la casella delle bozze). -->
                            <input type="checkbox" class="mr-1 align-middle"
                                :disabled="etichetteInPagina.length === 0"
                                :indeterminate.prop="etichetteParziale"
                                v-model="tutteEtichette"
                                :title="__('seleziona tutte le etichette di questa pagina per il foglio A4')">{{ __('Documenti') }}
                        </th>
                        <th class="px-2 py-2" :title="__('distinta di ritiro in cui è già la spedizione')">{{ __('Distinta') }}</th>
                        <th class="px-2 py-2"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="r in righe" :key="r.id" class="border-b border-gray-200 hover:bg-gray-50">
                        <td class="px-2 py-2">
                            <!-- importata da completare: non si trasmette finche' non la si sistema -->
                            <input v-if="trasmettibile(r)" type="checkbox" :value="r.id" v-model="selezionate">
                        </td>
                        <td class="px-2 py-2 font-mono">{{ r.numeratore || '—' }}</td>
                        <!-- 05/10/2026: trasmessa = confermata_at; bozza = creata il (in grigio) -->
                        <td class="px-2 py-2 whitespace-nowrap"
                            :class="{'text-gray-500 italic': !r.confermata_at}"
                            :title="r.confermata_at ? __('trasmessa') : __('bozza creata')">
                            {{ dataOra(r.confermata_at || r.created_at) }}
                        </td>
                        <!-- bozza senza data o con una data ormai passata: alla trasmissione
                             prende il primo giorno utile (oggi se lavorativo) -->
                        <td class="px-2 py-2 whitespace-nowrap"
                            :class="{'text-gray-500 italic': ldvDaAggiornare(r)}"
                            :title="ldvDaAggiornare(r) ? __('alla trasmissione diventa oggi (o il primo giorno lavorativo)') : ''">
                            {{ r.data_ldv ? dataGiorno(r.data_ldv) : '—' }}
                        </td>
                        <td class="px-2 py-2">
                            <span v-if="daCompletare(r)" class="px-2 py-1 rounded font-bold bg-red-100 text-red-700"
                                :title="r.import_errori">
                                {{ __('DA COMPLETARE') }}
                            </span>
                            <span v-else class="px-2 py-1 rounded font-bold" :class="coloreStato(r.stato)">
                                {{ etichettaStato(r.stato) }}
                            </span>
                            <div v-if="daCompletare(r)" class="text-red-700 mt-1 whitespace-pre-line" style="max-width: 22rem">
                                {{ r.import_errori }}
                            </div>
                        </td>
                        <td class="px-2 py-2">{{ r.rif_ddt }}</td>
                        <td class="px-2 py-2">{{ r.dest_ragsoc }}</td>
                        <td class="px-2 py-2">{{ r.dest_cap }} {{ r.dest_localita }} ({{ r.dest_provincia }})</td>
                        <td class="px-2 py-2">{{ formatoIt(r.colli, 0) }}</td>
                        <td class="px-2 py-2">{{ formatoIt(r.peso_totale, 2) }}</td>
                        <td class="px-2 py-2">{{ formatoIt(r.volume_totale, 2) }}</td>
                        <td class="px-2 py-2">
                            <!-- Annullata in AS400: i documenti ci sono ancora in archivio, ma
                                 non si stampano. Vedi BollettazioneService::documento(), che
                                 rifiuta anche se qualcuno chiama l'indirizzo a mano. -->
                            <span v-if="r.stato === 'ANNULLATA'" class="text-gray-400">
                                {{ __('annullata') }}
                            </span>
                            <span v-else-if="!r.documenti || r.documenti.length === 0" class="text-gray-400">
                                {{ r.stato === 'BOZZA' ? '—' : __('in attesa') }}
                            </span>
                            <span v-else class="whitespace-nowrap">
                                <!-- Un'icona per tipo, accesa solo se quel file e'
                                     arrivato davvero (SPEC 11). Si apre in una scheda
                                     nuova, cosi' l'elenco resta dov'e'. -->
                                <button v-if="haDocumento(r, 'LDV')" type="button"
                                    @click="apriDocumento(r, 'LDV')"
                                    class="text-red-600 underline mr-3">{{ __('LDV') }}</button>
                                <!-- La casella sceglie questa spedizione per il foglio A4.
                                     E' separata da quella di sinistra apposta: quella
                                     seleziona le BOZZE da confermare, questa le etichette
                                     gia' arrivate. Mescolarle vorrebbe dire confermare
                                     spedizioni mentre si prepara una stampa. -->
                                <input v-if="haDocumento(r, 'ETI')" type="checkbox"
                                    :value="r.numeratore" v-model="selEtichette"
                                    class="mr-1 align-middle"
                                    :title="__('aggiungi al foglio A4')">
                                <button v-if="haDocumento(r, 'ETI')" type="button"
                                    @click="apriDocumento(r, 'ETI')"
                                    class="text-red-600 underline">{{ __('etichette') }}</button>
                            </span>
                        </td>
                        <td class="px-2 py-2 whitespace-nowrap">
                            <span v-if="r.distinta_numero" class="font-bold">{{ r.distinta_numero }}</span>
                            <span v-else class="text-gray-400">—</span>
                        </td>
                        <td class="px-2 py-2 whitespace-nowrap">
                            <button v-if="r.stato === 'BOZZA'" type="button" @click="$emit('modifica', r)"
                                class="text-gray-700 hover:text-gray-900 underline mr-3">{{ __('modifica') }}</button>
                            <button v-if="r.stato === 'BOZZA'" type="button" @click="chiediElimina(r)"
                                class="text-red-600">{{ __('elimina') }}</button>
                        </td>
                    </tr>
                    <tr v-if="righe.length === 0">
                        <td colspan="15" class="px-2 py-4 text-gray-500">
                            {{ mostraTutte ? __('Nessuna spedizione.')
                                           : __('Nessuna spedizione da trasmettere o trasmessa oggi. Per lo storico spunta "mostra anche le più vecchie".') }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <Paginator :paginator="paginator" @searchPage="cambiaPagina"></Paginator>
        <Modal :modal="modal"></Modal>

        <!-- 22/10/2026 (Michele): prima del foglio A4 si sceglie da quale riquadro partire,
             per finire un foglio adesivo gia' iniziato. I riquadri prima di quello scelto
             restano vuoti (sono gia' stati usati); i fogli successivi partono da 1. -->
        <div v-if="sceltaA4" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-75"
            @click.self="sceltaA4 = false">
            <div class="bg-white rounded-lg shadow-xl p-4 w-72">
                <div class="font-semibold text-gray-900 mb-1">{{ __('Etichette A4') }}</div>
                <div class="text-xs text-gray-600 mb-3">{{ __('Da quale riquadro del foglio partire? Clic sul primo libero.') }}</div>
                <!-- il foglio A4 in piccolo (proporzioni 210 x 297), diviso in quattro -->
                <div class="mx-auto border-2 border-gray-500 grid grid-cols-2 grid-rows-2 gap-1 p-1 bg-gray-100"
                    style="width: 140px; height: 198px;">
                    <button v-for="n in 4" :key="n" type="button" @click="primoA4 = n"
                        class="rounded text-sm font-bold border focus:outline-none"
                        :class="n < primoA4
                            ? 'bg-gray-300 border-gray-400 text-gray-500 line-through'
                            : (n === primoA4 ? 'bg-red-600 border-red-700 text-white' : 'bg-white border-red-300 text-red-600')"
                        :title="n < primoA4 ? __('già usato: resta vuoto') : __('qui va un\'etichetta')">
                        {{ n < primoA4 ? __('usato') : n }}
                    </button>
                </div>
                <div class="text-xs text-gray-700 mt-3">
                    {{ __('Partenza dal riquadro') }} <b>{{ primoA4 }}</b>:
                    {{ selEtichette.length }} {{ selEtichette.length === 1 ? __('spedizione') : __('spedizioni') }}
                    {{ __('selezionate (ogni collo ha la sua etichetta).') }}
                </div>
                <div class="flex justify-end mt-4">
                    <button type="button" @click="sceltaA4 = false"
                        class="bg-gray-300 hover:bg-gray-400 text-gray-800 text-xs font-bold py-2 px-4 rounded mr-2">
                        {{ __('annulla') }}
                    </button>
                    <button type="button" @click="confermaA4"
                        class="bg-red-600 hover:bg-red-800 text-white text-xs font-bold py-2 px-4 rounded">
                        {{ __('stampa') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Paginator from './utility/Paginator.vue';
import Modal from './utility/Modal.vue';

/**
 * Elenco delle richieste del cliente.
 *
 * Si selezionano solo le BOZZE: dopo la conferma la spedizione e' immutabile e il
 * server la rifiuta comunque, ma non ha senso offrire una casella che non fa niente.
 *
 * La colonna Documenti oggi mostra soltanto se LDV ed etichette sono arrivate.
 * Le icone di download arriveranno con il watcher dei PDF: la rotta di scaricamento
 * non esiste ancora e non la invento adesso.
 */
export default {
    components: {
        Paginator,
        Modal
    },
    data() {
        return {
            righe: [],
            paginator: {},
            paginaCorrente: 1,
            selezionate: [],
            selEtichette: [],
            mostraTutte: false,
            modal: { show: false, title: '', body: [], buttons: undefined },
            timerAggiorna: null,
            // 22/10/2026: dopo una trasmissione si guarda piu' spesso finche' arrivano le etichette
            timerVeloce: null,
            // 22/10/2026: finestrella del foglio A4, riquadro da cui partire (1-4)
            sceltaA4: false,
            primoA4: 1,
            inAttesaEti: [],
            attesaFino: 0,
            daTrasmettere: 0,
            giornoDistinta: this.giornoLocale(),
            distinte: [],
            distintaScelta: null
        }
    },
    props: {
        /** true quando questa scheda e' quella in vista: il v-show la tiene montata anche nascosta. */
        attiva: {
            type: Boolean,
            default: true
        },
        /** Ultimo clic/tasto sulla pagina (Bollettazione.vue), in millisecondi. */
        ultimaAttivita: {
            type: Number,
            default: () => Date.now()
        }
    },
    watch: {
        // cambiando vista si riparte dalla prima pagina, e le selezioni si azzerano:
        // righe spuntate che spariscono dalla vista non devono restare selezionate
        mostraTutte() {
            this.selezionate = [];
            this.selEtichette = [];
            this.carica(1);
        }
    },
    mounted() {
        // I documenti arrivano da AS400 per conto loro, mentre la pagina e' aperta:
        // senza questo, per vederli bisogna ricordarsi di premere "aggiorna".
        this.timerAggiorna = setInterval(this.aggiornaDaSolo, 30 * 1000);
        this.caricaDistinte();
    },
    beforeDestroy() {
        if (this.timerAggiorna) {
            clearInterval(this.timerAggiorna);
            this.timerAggiorna = null;
        }
        this.fermaVeloce();
    },
    computed: {
        oggi() {
            return this.giornoLocale();
        },
        /** Id delle bozze visibili adesso: sono le uniche selezionabili. */
        bozzeInPagina() {
            return this.righe.filter(r => this.trasmettibile(r)).map(r => r.id);
        },
        /** Numeratori delle righe che hanno davvero le etichette in archivio. */
        etichetteInPagina() {
            return this.righe
                .filter(r => r.stato !== 'ANNULLATA' && this.haDocumento(r, 'ETI'))
                .map(r => r.numeratore);
        },
        /** Vero quando qualcuna e' selezionata ma non tutte: la casella in alto
         *  si disegna "a trattino" invece che spuntata. */
        selezioneParziale() {
            const n = this.selezionate.length;
            return n > 0 && n < this.bozzeInPagina.length;
        },
        etichetteParziale() {
            const n = this.etichetteInPagina.filter(x => this.selEtichette.includes(x)).length;
            return n > 0 && n < this.etichetteInPagina.length;
        },
        tutteEtichette: {
            get() {
                return this.etichetteInPagina.length > 0
                    && this.etichetteInPagina.every(n => this.selEtichette.includes(n));
            },
            set(valore) {
                this.selEtichette = valore ? this.etichetteInPagina.slice() : [];
            }
        },
        tutteSelezionate: {
            get() {
                return this.bozzeInPagina.length > 0
                    && this.bozzeInPagina.every(id => this.selezionate.includes(id));
            },
            set(valore) {
                this.selezionate = valore ? this.bozzeInPagina.slice() : [];
            }
        }
    },
    methods: {
        /** AAAA-MM-GG di oggi nell'ora LOCALE (toISOString darebbe il giorno UTC). */
        giornoLocale() {
            const d = new Date();
            const p = n => String(n).padStart(2, '0');
            return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate());
        },
        giornoIt(v) {
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v || ''));
            return m ? m[3] + '/' + m[2] + '/' + m[1] : '—';
        },
        /** Le ultime distinte, per la ristampa. Se non risponde la tendina non compare. */
        async caricaDistinte() {
            const res = await this.handleCallback(
                () => this.axios.post(this.$store.getters.uri + '/bollettazione/distinte', {}),
                false, false, false);
            const v = res && res.value ? res.value : res;
            this.distinte = Array.isArray(v) ? v : [];
            if (!this.distinte.some(d => d.id === this.distintaScelta)) {
                this.distintaScelta = this.distinte.length > 0 ? this.distinte[0].id : null;
            }
        },
        async creaDistinta() {
            if (!this.giornoDistinta) return;
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/distinta-crea',
                        { giorno: this.giornoDistinta }), false);
                const v = res && res.value ? res.value : res;
                if (v && v.id) {
                    await this.caricaDistinte();
                    this.distintaScelta = v.id;
                    await this.stampaDistinta(v.id);
                    // la colonna Distinta dell'elenco si aggiorna subito
                    await this.carica(this.paginaCorrente);
                    // creata, ma qualcuna del giorno non ha ancora il numero AS400
                    if (v.avviso) {
                        this.$emit('notify', false, this.__('Distinta') + ' ' + v.numero, v.avviso);
                    }
                }
                return res;
            });
        },
        async stampaDistinta(id) {
            if (!id) return;
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/distinta-pdf',
                        { id: id },
                        { responseType: 'arraybuffer' }),
                    false, false);
                if (!res || !res.byteLength) {
                    this.$emit('notify', false, this.__('Distinta non disponibile'),
                        this.__('Riprova; se il problema resta contatta la tua filiale.'));
                    return res;
                }
                const url = URL.createObjectURL(new Blob([res], { type: 'application/pdf' }));
                window.open(url);
                setTimeout(() => URL.revokeObjectURL(url), 60000);
                return res;
            });
        },
        /**
         * gg/mm/aaaa hh:mm nell'ora LOCALE. Il server manda le date in ISO-8601 con la
         * Z (UTC): new Date() le converte da solo; per sicurezza si accetta anche il
         * formato 'AAAA-MM-GG hh:mm:ss' senza fuso.
         */
        /** 22/10/2026: 'AAAA-MM-GG' (o con l'ora) -> 'GG/MM/AAAA'. */
        dataGiorno(v) {
            const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(v || ''));
            return m ? m[3] + '/' + m[2] + '/' + m[1] : '';
        },
        /** Bozza la cui data LDV cambiera' alla trasmissione (vuota o gia' passata). */
        ldvDaAggiornare(r) {
            if (r.confermata_at || r.stato !== 'BOZZA') return false;
            const d = String(r.data_ldv || '').substring(0, 10);
            return d === '' || d < this.giornoLocale();
        },
        dataOra(v) {
            if (!v) return '—';
            const d = new Date(String(v).indexOf('T') > 0 ? v : String(v).replace(' ', 'T'));
            if (isNaN(d.getTime())) return '—';
            const p = n => String(n).padStart(2, '0');
            return p(d.getDate()) + '/' + p(d.getMonth() + 1) + '/' + d.getFullYear()
                + ' ' + p(d.getHours()) + ':' + p(d.getMinutes());
        },
        /** Bozza arrivata da un file con errori: va aperta e salvata dalla maschera (08/10/2026). */
        daCompletare(r) {
            return r.stato === 'BOZZA' && !!r.import_errori;
        },
        trasmettibile(r) {
            return r.stato === 'BOZZA' && !r.import_errori;
        },
        /** Solo la scritta: il valore in tabella resta BOZZA. */
        etichettaStato(stato) {
            return stato === 'BOZZA' ? this.__('DA TRASMETTERE') : stato;
        },
        /**
         * Quante spedizioni aspettano di essere trasmesse, su tutto l'elenco. Stessa
         * chiamata del promemoria della home; se non risponde il banner non compare,
         * senza messaggi di errore: e' un aiuto, non una funzione.
         */
        async contaDaTrasmettere() {
            try {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/bozze', {}),
                    false, false, false);
                const v = res && res.value ? res.value : res;
                this.daTrasmettere = v && typeof v.numero !== 'undefined' ? (Number(v.numero) || 0) : 0;
            } catch (e) {
                this.daTrasmettere = 0;
            }
        },
        coloreStato(stato) {
            switch (stato) {
                case 'BOZZA': return 'bg-gray-200 text-gray-700';
                case 'CONFERMATA': return 'bg-blue-100 text-blue-700';
                case 'IN_INVIO':
                case 'INVIATA': return 'bg-yellow-100 text-yellow-800';
                case 'COMPLETA': return 'bg-green-100 text-green-800';
                case 'ALLARME': return 'bg-red-200 text-red-800';
                // annullata in AS400: non e' un errore del tracking, e' una decisione
                case 'ANNULLATA': return 'bg-gray-300 text-gray-700 line-through';
                default: return 'bg-gray-200 text-gray-700';
            }
        },
        haDocumento(r, tipo) {
            return (r.documenti || []).some(doc => doc.tipo === tipo);
        },

        /**
         * Apre il PDF in una scheda nuova.
         *
         * Si passa dal POST con il token, non da un <a href>: il tracking riconosce
         * chi sei dall'intestazione Authorization, che un link normale non manda.
         * E' la stessa strada dello Storico POD.
         *
         * Al server si danno solo numeratore e tipo, MAI il nome del file: il nome
         * lo trova lui in bol_documenti dopo aver controllato che la spedizione sia
         * tua (SPEC 11).
         */
        async apriDocumento(r, tipo) {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/documento',
                        { numeratore: r.numeratore, tipo: tipo },
                        { responseType: 'arraybuffer' }),
                    false, false);          // il messaggio di errore lo diamo noi qui sotto
                if (!res || !res.byteLength) {
                    this.$emit('notify', false, this.__('Documento non disponibile'),
                        this.__('Riprova fra poco. Se continua, segnalalo.'));
                    return res;
                }
                const url = URL.createObjectURL(new Blob([res], { type: 'application/pdf' }));
                window.open(url);
                // si libera la memoria, ma dopo: revocarlo subito chiuderebbe la scheda
                // appena aperta prima che abbia finito di leggere il file
                setTimeout(() => URL.revokeObjectURL(url), 60000);
                return res;
            });
        },

        /**
         * Il foglio A4 con le etichette spuntate, quattro per pagina in scala 1:1.
         *
         * Stessa strada di apriDocumento(): POST con il token e apertura in una
         * scheda nuova. Al server vanno solo i numeratori; il PDF lo compone lui
         * leggendo i file da archivio, dopo aver controllato che le spedizioni
         * siano di chi le chiede.
         */
        async stampaEtichetteA4() {
            await this.stampaEtichetteUnite('etichette-a4', { primo: this.primoA4 });
        },
        /** 22/10/2026: prima del foglio A4 la scelta del riquadro di partenza (sempre da 1 all'apertura). */
        apriSceltaA4() {
            if (this.selEtichette.length === 0) return;
            this.primoA4 = 1;
            this.sceltaA4 = true;
        },
        async confermaA4() {
            this.sceltaA4 = false;
            await this.stampaEtichetteA4();
        },
        /** 13/10/2026: stesse etichette, una per pagina nel formato dell'etichetta (10x10). */
        async stampaEtichette10x10() {
            await this.stampaEtichetteUnite('etichette-10x10');
        },
        async stampaEtichetteUnite(rotta, altro = {}) {
            if (this.selEtichette.length === 0) return;
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/' + rotta,
                        Object.assign({ numeratori: this.selEtichette }, altro),
                        { responseType: 'arraybuffer' }),
                    false, false);
                if (!res || !res.byteLength) {
                    this.$emit('notify', false, this.__('Etichette non disponibili'),
                        this.__('Controlla le spedizioni selezionate e riprova.'));
                    return res;
                }
                const url = URL.createObjectURL(new Blob([res], { type: 'application/pdf' }));
                window.open(url);
                setTimeout(() => URL.revokeObjectURL(url), 60000);
                return res;
            });
        },

        /**
         * Il giro automatico ogni 30 secondi. Si tira indietro in questi casi, e sono i casi
         * in cui ricaricare darebbe fastidio invece che aiutare:
         *   - la scheda non e' in vista (il cliente sta compilando il modulo);
         *   - c'e' una finestra aperta (conferma o eliminazione): sparirebbe da sola.
         *     NON la finestra "Spedizioni trasmesse" (22/10/2026): e' solo un avviso, e
         *     il cliente che la lascia aperta aspettando le etichette vedeva l'elenco fermo;
         *   - nessuno tocca niente da mezz'ora.
         * Le caselle spuntate NON lo fermano piu' (22/10/2026): carica() le conserva.
         * Il tasto "aggiorna" resta li' per chi vuole farlo comunque.
         */
        async aggiornaDaSolo() {
            if (!this.puoAggiornare()) return;
            await this.carica(this.paginaCorrente);
        },

        /** Le condizioni del giro automatico (vedi sopra), in un posto solo. */
        puoAggiornare() {
            if (!this.attiva) return false;
            // Dopo mezz'ora senza nessuno davanti si smette di aggiornare (01/10/2026).
            // Ogni aggiornamento e' una chiamata al server, e con il token scaduto la
            // chiamata lo rinnova: una scheda lasciata aperta di notte teneva viva la
            // sessione all'infinito, scavalcando sia il controllo di attivita' del
            // rinnovo in Bollettazione.vue sia JWT_REFRESH_TTL. Al primo clic riparte.
            if (Date.now() - this.ultimaAttivita > 30 * 60 * 1000) return false;
            if (this.modal.show && !this.modal.informativa) return false;
            // 22/10/2026: tolto il blocco con bozze o etichette spuntate. Con un'etichetta
            // spuntata l'elenco restava fermo e le etichette nuove non comparivano (visto in
            // produzione). Non serviva: carica() tiene le selezioni ancora valide e toglie
            // solo le righe sparite o cambiate di stato.
            return true;
        },

        /**
         * 22/10/2026: subito dopo una trasmissione l'elenco si rilegge ogni 5 secondi,
         * finche' le spedizioni appena trasmesse hanno l'etichetta (o sono annullate),
         * al massimo per 2 minuti; poi resta il giro normale da 30 secondi. Le etichette
         * arrivano in 5-30 secondi: col solo giro da 30 il cliente ne aspettava fino al doppio.
         */
        avviaVeloce(numeri) {
            this.inAttesaEti = Array.from(new Set(this.inAttesaEti.concat(numeri || [])));
            if (this.inAttesaEti.length === 0) return;
            this.attesaFino = Date.now() + 2 * 60 * 1000;
            if (!this.timerVeloce) {
                this.timerVeloce = setInterval(this.aggiornaVeloce, 5 * 1000);
            }
        },
        fermaVeloce() {
            if (this.timerVeloce) {
                clearInterval(this.timerVeloce);
                this.timerVeloce = null;
            }
            this.inAttesaEti = [];
        },
        async aggiornaVeloce() {
            if (this.inAttesaEti.length === 0 || Date.now() > this.attesaFino) {
                this.fermaVeloce();
                return;
            }
            if (!this.puoAggiornare()) return;
            await this.carica(this.paginaCorrente);
            // tolgo quelle arrivate, annullate o non piu' in vista (non si potrebbero vedere comunque)
            this.inAttesaEti = this.inAttesaEti.filter(n => {
                const r = this.righe.find(x => x.numeratore === n);
                return r && r.stato !== 'ANNULLATA' && !this.haDocumento(r, 'ETI');
            });
            if (this.inAttesaEti.length === 0) {
                this.fermaVeloce();
            }
        },

        async carica(pagina = 1) {
            this.paginaCorrente = pagina;
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/lista', {
                        risultati_pagina: 25,
                        page: pagina,
                        tutte: this.mostraTutte
                    }), false);
                if (res) {
                    const p = res.value ? res.value : res;
                    this.righe = p.data || [];
                    this.paginator = p;
                    // tolgo dalla selezione le righe che non sono piu' bozze o non ci sono piu'
                    const bozze = this.righe.filter(r => this.trasmettibile(r)).map(r => r.id);
                    this.selezionate = this.selezionate.filter(id => bozze.includes(id));
                    // stessa cosa per le etichette: se una spedizione e' stata annullata
                    // o e' finita in un'altra pagina, la sua casella non vale piu'
                    const stampabili = this.etichetteInPagina;
                    this.selEtichette = this.selEtichette.filter(n => stampabili.includes(n));
                    this.contaDaTrasmettere();
                }
                return res;
            });
        },

        cambiaPagina(url) {
            if (!url) return;
            const m = /[?&]page=(\d+)/.exec(url);
            this.carica(m ? Number(m[1]) : 1);
        },

        chiediElimina(r) {
            this.modal = {
                show: true,
                title: this.__('Eliminare la bozza?'),
                body: [{ value: (r.rif_ddt || '') + ' - ' + (r.dest_ragsoc || '') }],
                buttons: [
                    { title: this.__('elimina'), click: () => { this.modal.show = false; this.elimina(r.id); } },
                    { title: this.__('annulla'), click: () => { this.modal.show = false; } }
                ]
            };
        },

        async elimina(id) {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/elimina', { id: id }), true);
                if (res) await this.carica(this.paginaCorrente);
                return res;
            });
        },

        conferma() {
            if (this.selezionate.length === 0) return;
            this.modal = {
                show: true,
                title: this.__('Trasmettere a Tardini le spedizioni selezionate?'),
                body: [{
                    value: this.__('Da questo momento non si possono più modificare né annullare dal sito.')
                        + '<br><b>' + this.selezionate.length + '</b> ' + this.__('spedizioni'),
                    action: () => {}
                }],
                buttons: [
                    { title: this.__('trasmetti'), click: () => { this.modal.show = false; this.confermaOra(); } },
                    { title: this.__('annulla'), click: () => { this.modal.show = false; } }
                ]
            };
        },

        /** Avviso di admin da mostrare adesso, o null (13/10/2026). Mai un errore a video. */
        async testoAvviso() {
            try {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/avviso', {}), false, false, false);
                const v = res && res.value ? res.value : res;
                return v && v.testo ? String(v.testo) : null;
            } catch (e) {
                return null;
            }
        },

        escapaHtml(t) {
            return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
        },

        async confermaOra() {
            await this.storeLogTime(async () => {
                const res = await this.handleCallback(
                    () => this.axios.post(this.$store.getters.uri + '/bollettazione/conferma',
                        { ids: this.selezionate }), false);
                if (res) {
                    const numeri = res.value ? res.value : res;
                    const elenco = Array.isArray(numeri) ? numeri.join(', ') : '';
                    // 13/10/2026: con l'avviso di admin acceso (es. AS400 spento) i 30 secondi
                    // non sono veri: al loro posto il testo dell'avviso. La finestra usa v-html,
                    // quindi il testo si ESCAPA.
                    const avviso = await this.testoAvviso();
                    this.modal = {
                        show: true,
                        // 22/10/2026: avviso, non blocca il giro automatico (puoAggiornare)
                        informativa: true,
                        title: this.__('Spedizioni trasmesse'),
                        body: [{
                            value: (elenco ? '<b>' + elenco + '</b><br><br>' : '')
                                + (avviso
                                    ? '<b>' + this.escapaHtml(avviso) + '</b>'
                                    : this.__('Etichette e lettere di vettura saranno disponibili in questo elenco tra circa 30 secondi.'))
                                + '<br>' + this.__('Nel frattempo potete continuare a inserire altre spedizioni.')
                                + '<br><br>' + this.__('Per modifiche o annullamenti contattate la vostra filiale di riferimento.'),
                            action: () => {}
                        }],
                        buttons: [
                            { title: this.__('ok'), click: () => { this.modal.show = false; } }
                        ]
                    };
                    this.selezionate = [];
                    await this.carica(this.paginaCorrente);
                    // 22/10/2026: si guarda ogni 5 secondi finche' arrivano le etichette
                    this.avviaVeloce(Array.isArray(numeri) ? numeri : []);
                    // 19/10/2026: la pagina rilegge gli avvisi (fascia "manca la richiesta di presa")
                    this.$emit('trasmesse');
                }
                return res;
            });
        }
    }
}
</script>
